// src/components/shops/postTemplates/Split.tsx
//
// Half photograph, half solid colour carrying the words — the oldest layout in
// advertising, and the reason it survives is that text set on a colour block
// never has to fight the picture underneath it.
//
// With no photo the colour block simply takes the whole card, which still
// looks deliberate rather than broken.

import { cachedUrl } from '../../../lib/storageUrl'
import SocialBrewBadge from '../SocialBrewBadge'
import { categoryLabel, type TemplateProps } from './types'

export default function Split({
  title, body, photos, category, shopName, rating, ratingCount, scale = 1,
}: TemplateProps) {
  const px = (n: number) => `${n * scale}px`
  const label = categoryLabel(category)
  const photo = photos[0]

  return (
    <div className="overflow-hidden" style={{ borderRadius: px(3) }} data-shop={shopName}>
      {photo && (
        <div style={{ aspectRatio: '1 / 1' }}>
          <img src={cachedUrl(photo)} alt="" loading="lazy" className="w-full h-full object-cover" />
        </div>
      )}

      <div style={{ background: '#38261c', padding: `${px(20)} ${px(18)} ${px(16)}` }}>
        {label && (
          <p
            style={{
              fontSize: px(8.5),
              letterSpacing: '0.3em',
              textTransform: 'uppercase',
              color: '#e0a45f',
              fontWeight: 700,
              marginBottom: px(9),
            }}
          >
            {label}
          </p>
        )}
        <h3
          className="font-display"
          style={{
            fontSize: px(24),
            lineHeight: 1.14,
            letterSpacing: '-0.015em',
            color: '#f7efe1',
            fontWeight: 700,
            margin: 0,
            textWrap: 'balance',
          }}
        >
          {title}
        </h3>
        {body && (
          <p style={{ fontSize: px(13), lineHeight: 1.62, color: 'rgba(247,239,225,0.72)', marginTop: px(9) }}>
            {body}
          </p>
        )}

        <div style={{ marginTop: px(18) }}>
          <SocialBrewBadge rating={rating} ratingCount={ratingCount} tone="dark" scale={scale} />
        </div>
      </div>
    </div>
  )
}
